import { isEmpty } from 'lodash'

export default function isPresent(value) {
  return !isEmpty(value)
}
